import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Html5QrcodeScanner, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import { snackShow } from '../../../../../actions';
import { change } from 'redux-form';

const qrcodeRegionId = 'html5qr-code-full-region';

const errorCb = error => {
  // console.error('Error while rendering html5qrcode', error)
};

// eslint-disable-next-line arrow-body-style
const createConfig = props => {
  return {
    fps: 10,
    qrbox: {
      width: 250,
      height: 100
    },
    disableFlip: false,
    rememberLastUsedCamera: true,
    useBarCodeDetectorIfSupported: true,
    formatsToSupport: [
      Html5QrcodeSupportedFormats.CODE_128,
      Html5QrcodeSupportedFormats.CODE_39,
      Html5QrcodeSupportedFormats.CODE_93
    ]
  };
};

class VinScannerFileUpload extends Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
  }

  startVinScanner = () => {
    const { setBarcodeValue, successfullScan } = this.props;
    this.html5QrcodeScanner = new Html5QrcodeScanner(qrcodeRegionId, createConfig(), false);
    this.html5QrcodeScanner.render((decodedText, decodedResult) => {
      console.log(change);
      console.log(`FOUND ${decodedText}`);
      successfullScan();
      setBarcodeValue(decodedText);
      this.html5QrcodeScanner.clear();
    }, errorCb);
  };

  render() {
    return (
      <>
        <a
          href="#vinScanner"
          onClick={e => {
            e.preventDefault();
            this.startVinScanner();
          }}
        >
          Use VIN Scanner
        </a>
        <div id={qrcodeRegionId} />
      </>
    );
  }
}

export default connect(null, dispatch => ({
  setBarcodeValue: value => dispatch(change('vinForm', 'vin', value)),
  successfullScan: () =>
    dispatch(
      snackShow({
        message: 'Scan was successfull'
      })
    ),
  unsuccessfullScan: () =>
    dispatch(
      snackShow({
        message: 'Scan was unsuccessfull',
        type: 'error'
      })
    )
}))(VinScannerFileUpload);
